import React, { Component } from 'react';
import axios from 'axios';
import Sidenav from '../pages/Sidenav';
import API from '../config_api'
import '../css/App.css';
import Card from '../component/Card';
import Footer from '../component/Footer';
import { fetchData } from '../redux/assignedData/AssignAction'
import { connect } from 'react-redux';
import { Doughnut } from 'react-chartjs-2';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import Loader from '../component/Loader';
import { ProgressBar } from 'react-bootstrap';
import IdleTimerLogout from './IdleTimerLogout';

class DashBoard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            insights: '',
            red: '',
            blue: '',
            orange: '',
            green: '',
            percentage: '',
            loading1: false,
            loading2: false,
            offline: []
        };

    }
    componentWillMount() {

        if (!localStorage.getItem('token')) {
            this.props.history.push('/');
        }
        else {
            this.props.getAreaData();
            let formData = new FormData();
            formData.append('user_id', localStorage.getItem('token'))

            axios({
                method: 'post',
                url: API.Dashboard,
                data: formData,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                mode: 'no-cors',
            })
                .then(res => {
                    this.setState({
                        loading1: true
                    })
                    if (res.data.status === 'success') {
                        this.setState({ data: res.data.data })
                        console.log(res.data.data);
                    }
                    else {
                        alert(res.data.message)
                    }
                });

            axios({
                method: 'post',
                url: API.UserReport,
                data: formData,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                mode: 'no-cors',
            })
                .then(res => {
                    console.log(res);
                    this.setState({ loading2: true })
                    // this.setState({ red: res.data.data.insights.red })
                    // this.setState({ green: res.data.data.insights.green })
                    // this.setState({ red: res.data.data.insights.blue })
                    // this.setState({ orange: res.data.data.insights.orange })
                    this.setState({ insights: res.data.data.insights })
                    this.setState({ percentage: res.data.data.overall_percentage })
                    this.setState({ offline: res.data.data.offline_percentage })
                    console.log(res.data.data);

                });



        }
    }

    units(item) {
        var len = 0;
        item.models.forEach(element1 => {
            len += element1.programs.length;
        });
        return len;
    }
    btnAction(models) {
        localStorage.setItem('area', models.name)
        this.props.history.push('/unit', { data: models })
    }
    render() {
        return (

            <div className=" ">

                <Sidenav type={"main"} push={this.props.history} notification={this.state.data.notification > 0 ? true : false} />


                <div className="container">
                    <div style={{ position: 'fixed', left: 0, right: 0, zIndex: 1 }}>
                        <div className="container">
                            <div className="row">
                                <div className="col"> <div className="pt-2 pb-2">Hello <span style={{ fontSize: 20, fontWeight: 600 }}>{localStorage.getItem('firstname')}  {localStorage.getItem('lastname')} !</span></div></div>
                            </div>
                        </div>
                    </div>
                    <div style={{ height: 50 }}></div>

                    <div className="row marLeft-5 marRight-5" >
                        <div className="col-6 flex pad_z">
                            <Card type={"1"} Title={"Modules"} img={require('../images/modules.png')} Count={this.state.data.unit_assigned} Push={this.props.history} Url={"/area"} />

                        </div>
                        <div className="col-6  pad_z">
                            <div className="flex">
                                <div className="card flex justify-content-between" onClick={() => this.props.history.push('/star')}>
                                    <div className=" flex justify-content-center align-item-center">
                                        < img src={require('../images/star.png')} alt="bulp" style={{ width: 40 }} />

                                    </div>

                                    <div className=" flex justify-content-center align-item-center">
                                        <h5 className="size-text">Starred</h5>
                                    </div>

                                </div>
                                <Card type={"4"} Title={"Scan"} img={require('../images/qrcode1.png')} Push={this.props.history} Url={"/qrscan"} />
                            </div>
                            {/* <div className="flex" >
                                    <Card type={"2"} Title={"Resume"} img={require('../images/resume2.png')} Count={this.state.data.paused} Push={this.props.history} Url={"/resume"} />

                                </div> */}
                            <div className="flex" onClick={() => this.props.history.push('/classroom')}>
                                <div className="card flex" >
                                    <div className=" flex justify-content-between" >
                                        <div className="align-item-center">
                                            < img src={require('../images/notes.png')} alt="bulp" style={{ width: 40 }} />
                                            <h5 className="size-text">Classroom Training Record</h5>
                                        </div>
                                        <div className="align-item-center">


                                            <span className="material-icons">
                                                keyboard_arrow_right
                                            </span>
                                        </div>


                                    </div>

                                </div>
                            </div>





                        </div>
                    </div>
                    {/* <div className=" card pad_z m-0 mb-2 " >
                            <div style={{ position: 'fixed', left: 0, right: 0, zIndex: 1 }}>
                                <div className="container">
                                    <div className="row m-0 mr-3" style={{ background: '#fff' }}>
                                        <div className="col-md-12 text-center" style={{ padding: 10 }}>
                                            <h5 className="size-text">Modules</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ height: 40, width: '100%' }}></div>
                            <div className=" row m-0 flex-row scroll" style={{ height: 370, overflowY: 'scroll', background: '#fff', padding: '5px 0' }}>
                                {this.props.data.map((item, i) => {
                                    return (
                                        <div className="col-md-4 col-sm-12 col-xs-12 pad_z" key={i}>
                                            <div className="card justify-content-center row" style={{ padding: 10, margin: 10 }} onClick={() => this.btnAction(item)}>
                                                <div className=" padZero flex text-center justify-content-center" style={{ marginBottom: 10, fontWeight: 500 }}>{item.name} </div>
                                                <div className="flex justify-content-center align-item-center">
                                                    <div className="flex justify-content-between">
                                                        {item.image ?
                                                            <img src={item.image} alt="logo" className="responsive-img" style={{ width: 50, height: 50 }} />
                                                            : <span className="letter" style={{ width: 50, height: 50, fontSize: 17 }}>{item.name.charAt(0)}</span>}
                                                        <span className="topic"><p className="flex mZero" style={{ fontSize: 12 }}><span style={{ paddingRight: 5 }}>{item.models.length} </span> <span> Topic(s)</span></p>
                                                            <p className="flex mZero" style={{ fontSize: 12 }}><span style={{ paddingRight: 5 }}>{this.units(item)} </span> <span> Unit(s)</span> </p>
                                                        </span>
                                                    </div>

                                                    <div className=" text-right"><i className="material-icons">
                                                        keyboard_arrow_right
</i></div></div>
                                            </div></div>
                                    )
                                })}
                            </div>
                        </div> */}
                    {/* <div className="row marLeft-5 marRight-5" >
                            <Card type={"2"} Title={"Groups"} img={require('../images/chat_yellow.png')} Count={this.state.data.no_of_assigned_groups} Push={this.props.history} Url={"/groups"} />
                        </div> */}
                    <div className="row marLeft-5 marRight-5" >
                        <div className="flex ">
                            <Card type={"3"} Title={"Checklists"} img={require('../images/checkbox1.png')} Push={this.props.history} Url={"/checklist"} />
                            <Card type={"3"} Title={"Documents"} img={require('../images/forms5.png')} Push={this.props.history} Url={"/suggestion"} />
                            <Card type={"3"} Title={"Forms"} img={require('../images/docs2.png')} Push={this.props.history} Url={"/observation"} />
                        </div>
                    </div>

                    <div className="row marLeft-5 marRight-5" >
                        {/* <div className="flex ">
                            <Card type={"2"} Title={"Collaborate"} img={require('../images/collaborate3.png')} Count={this.state.data.no_of_assigned_groups} Push={this.props.history} Url={"/groups"} />
                        </div> */}
                        <div className="flex" onClick={() => this.props.history.push('/certificate')}>
                            <div className="card flex" >
                                <div className=" flex justify-content-between" >
                                    <div className="align-item-center">
                                        <i className='fa fa-certificate fa-2x' style={{ width: 40 }} />
                                        <h5 className="size-text">Certificate</h5>
                                    </div>
                                    <div className="align-item-center">


                                        <span className="material-icons">
                                            keyboard_arrow_right
                                        </span>
                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>

                    {/* <div className="row marLeft-5 marRight-5" > */}
                    {/* <div className="col-6 flex pad_z flex-column"> */}

                    <div className="card mb-0 mr-0 ml-0  pad_z" onClick={() => this.props.history.push('/insight')}>
                        <div className="row">
                            <div className="col-md-12 text-center" style={{ paddingBottom: 2 }}>
                                <h5 className="size-text">Insights</h5>
                            </div>
                        </div>
                        <div className=" flex justify-content-between align-item-center">
                            <div className="align-item-center justify-content-between" style={{ width: '100%' }}>
                                <div className="flex justify-content-center flex-column align-item-center">
                                    <div style={{ width: 120, height: 'auto', position: 'relative' }}>
                                        <div className="index">{this.state.insights.insight_index === null ? "No Data" : Math.round(this.state.insights.insight_index)}</div>
                                        <Doughnut
                                            data={{
                                                labels: ['High Risk', 'Lucky', 'Low Risk',
                                                    'Risky'],
                                                datasets: [
                                                    {

                                                        backgroundColor: [
                                                            '#be1f24',
                                                            '#005284',
                                                            '#7ed321',
                                                            '#f5a623'
                                                        ],
                                                        hoverBackgroundColor: [
                                                            '#be1f24',
                                                            '#005284',
                                                            '#7ed321',
                                                            '#f5a623'
                                                        ],
                                                        borderWidth: 0,
                                                        data: [Math.round(this.state.insights.red), Math.round(this.state.insights.blue), Math.round(this.state.insights.green), Math.round(this.state.insights.orange)],
                                                        weight: 2
                                                    }
                                                ]
                                            }}

                                            width={120}
                                            height={100}
                                            options={{
                                                title: {
                                                    display: false,

                                                },
                                                legend: {
                                                    display: false,

                                                },
                                                cutoutPercentage: 80

                                            }}

                                        />
                                    </div>
                                    <h4 style={{ margin: '2px' }}>Knowledge Index</h4>
                                </div>
                                <div className="flex justify-content-center flex-column align-item-center" >
                                    <div style={{ width: 100, height: 'auto' }}>
                                        <CircularProgressbar value={this.state.percentage} text={`${Math.round(this.state.percentage)}%`} strokeWidth={9} /></div>
                                    <h4 style={{ margin: '2px' }}>Pull Rate</h4>
                                </div>
                            </div>
                            <div className="align-item-center">
                                <span className="material-icons">
                                    keyboard_arrow_right
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="card mb-0 mr-0 ml-0 mt-3  pad_z" >
                        <div className="row">
                            <div className="col-md-12 text-center" style={{ paddingBottom: 2 }}>
                                <h5 className="size-text">Classroom Training</h5>
                            </div>
                        </div>
                        <div className=" flex justify-content-center align-item-center">

                            <div className='p-2 text-center'>
                                <h3>{this.state.offline.no_of_session}</h3>
                                <p>Session</p>

                            </div>

                            <div className='p-2 text-center'>
                                <h3>{this.state.offline.session_duration}</h3>
                                <p>Duration</p>
                            </div>

                        </div>

                        <div className="d-flex w-100 px-3">
                            <ProgressBar
                                now={this.state.offline.average}
                                label={`${Math.round(this.state.offline.average)}%`}
                                style={{ width: '100%', height: 15 }}
                            />
                        </div>

                    </div>
                    {/* </div> */}
                    {/* <div className="col-6  pad_z">
                                <div className="flex" >
                                    <Card type={"2"} Title={"Collaborate"} img={require('../images/group_icon.png')} Count={this.state.data.no_of_assigned_groups} Push={this.props.history} Url={"/groups"} />
                                    <Card type={"2"} Title={"Resume"} img={require('../images/resume_filled.png')} Count={this.state.data.paused} Push={this.props.history} Url={"/resume"} />
                                </div>
                                <div className="flex">
                                    <Card type={"3"} Title={"Checklists"} img={require('../images/checkbox1.png')} Push={this.props.history} Url={"/checklist"} />
                                    <Card type={"3"} Title={"Documents"} img={require('../images/forms4.png')} Push={this.props.history} Url={"/suggestion"} />
                                    <Card type={"3"} Title={"Forms"} img={require('../images/docs2.png')} Push={this.props.history} Url={"/observation"} />
                                </div>
                            </div> */}

                    {/* </div> */}
                </div>





                {(!this.state.loading1 && !this.state.loading2 && this.props.loader) && <Loader />}



                <Footer page="dashboard" Push={this.props.history} />
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        data: state.assign.data,
        loader: state.assign.loading,
        error: state.assign.error
    }
}
const mapDispatchToProps = dispatch => {
    return {
        getAreaData: () => dispatch(fetchData())
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DashBoard);
